(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["product-spotlight-carousel"] && !Shopify.designMode) return;
  try {
    
  document.querySelectorAll('[data-spotlight-carousel]').forEach((carousel) => {
    const slides = Array.from(carousel.querySelectorAll('[data-spotlight-slide]'));
    const dots = Array.from(carousel.querySelectorAll('[data-spotlight-dot]'));
    const interval = Number(carousel.dataset.spotlightInterval || 4000);
    let activeIndex = 0;
    let timer;

    if (slides.length < 2) return;

    const setActive = (nextIndex) => {
      activeIndex = (nextIndex + slides.length) % slides.length;

      slides.forEach((slide, index) => {
        slide.classList.toggle('is-active', index === activeIndex);
      });

      dots.forEach((dot, index) => {
        dot.classList.toggle('is-active', index === activeIndex);
      });
    };

    const start = () => {
      window.clearInterval(timer);
      timer = window.setInterval(() => setActive(activeIndex + 1), interval);
    };

    dots.forEach((dot, index) => {
      dot.addEventListener('click', () => {
        setActive(index);
        start();
      });
    });

    carousel.addEventListener('mouseenter', () => window.clearInterval(timer));
    carousel.addEventListener('mouseleave', start);
    start();
  });

  } catch(e) { console.error(e); }
})();
})();
